export enum UpdateCrmTabsType {
  PROPERTY = 'property',
  SUBSCRIPTION = 'subscription',
  PRICES = 'prices',
  BALANCE = 'balance',
}
